import axiosService from "@/services/axios-service";
import RESTApiEndPoints from "@/services/rest-api-end-points";
import IPoolDrainOptions from "@/models/pool-drain-options";

export default class PoolDrainOptionsService {
  public async GetPoolDrainOptions() {
    return axiosService.get<IPoolDrainOptions[]>(RESTApiEndPoints.poolDrainOptionsUrl());
  }
  public async PostPoolDrainOption(poolDrainOptions: IPoolDrainOptions) {
    return axiosService.post<IPoolDrainOptions>(
      RESTApiEndPoints.poolDrainOptionsUrl(),
      poolDrainOptions
    );
  }

  public async PutPoolDrainOption(poolDrainOptionsId: number, poolDrainOptions: IPoolDrainOptions) {
    return axiosService.put(
      `${RESTApiEndPoints.poolDrainOptionsUrl()}/${poolDrainOptionsId}`,
      poolDrainOptions
    );
  }
  public async DeletePoolDrainOption(poolDrainOptionsId: number) {
    return axiosService.delete(`${RESTApiEndPoints.poolDrainOptionsUrl()}/${poolDrainOptionsId}`);
  }
}
